<div class="container">
  <img src="../../../../assets/img/trader_logo_aprovado.png" class="logo-size-small" alt="Logo do Itaú Trader" aria-hidden="true">
  <h3 class="title">Desculpe, algo deu errado</h3>
  <ids-icon class="close-icon" size="L">fechar</ids-icon>

  <span class="lighter-font">Ocorreu um erro ao acessar essa aplicação, tente novamente</span>
  <span>Se este erro persistir contate a equipe de câmbio <span *ngIf="codeError || correlationId">e informe o código de erro</span>
    <span *ngIf="codeError && attemptRedirect!==0"> {{ codeError }}</span><span *ngIf="correlationId && attemptRedirect!==0"> {{ correlationId }}</span>
  </span>
  <span>
    <a class="ids-link ids-link--dark" title="tentar novamente" href="/" rel="external">Tentar novamente</a>
  </span>
  <small>Você será redirecionando automaticamente em {{ timerRedirect }}</small>
</div>
